import { AgricultureMapConstants, LAYER_TYPES, LOCATIONS_ZOOM_RANGE } from 'src/app/main/constants/dims-map-constants';

export const LOCATION_HIE: any = ['COUNTRY', 'STATE', 'DISTRICT', 'BLOCK'];

export const SATELLITE_LAYER_LIST: any = {
  [AgricultureMapConstants.LOCATIONS.INDIA]: {
    'India Boundary': {
      source: 'INDIA',
      displayName: 'India',
      name: 'India Boundary',
      visible: true,
      view: AgricultureMapConstants.VIEWS.ADMIN,
      dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
      layerptions_show_on_selector: false,
      layeroptions_name: 'odisha:india_boundary',
      layer_name: 'India Boundary',
      layeroptions_pane: 'max',
      layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.STATE].MIN - 2,
      layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.STATE].MAX,
      group: 'boundaries',
      group_type: 'radio-deselect',
      layerServiceType: LAYER_TYPES.GEOJSON_LAYER,
      type: LAYER_TYPES.GEOJSON_LAYER,
      cql_filter_value: null,
      cql_filter: null,
      layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
      environment_server_url: 'COMMON_GEOSERVER_URL',
      crs: 'EPSG4326',
      onEachFeature: 'handleAdminPolygons',
      layeroptions_protocol: 'WFS'
    },
    'Country Boundaries': {
      source: 'INDIA',
      displayName: 'Country Boundaries',
      name: 'Country Boundaries',
      visible: true,
      view: AgricultureMapConstants.VIEWS.ADMIN,
      dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
      layerptions_show_on_selector: false,
      layeroptions_name: 'odisha:india_boundary',
      layer_name: 'Country Boundaries',
      layeroptions_pane: 'depth',
      layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.STATE].MIN - 1,
      layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.STATE].MAX,
      group: 'boundaries',
      group_type: 'radio-deselect',
      layerServiceType: LAYER_TYPES.GEOJSON_LAYER,
      type: LAYER_TYPES.GEOJSON_LAYER,
      cql_filter_value: null,
      cql_filter: null,
      layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
      environment_server_url: 'COMMON_GEOSERVER_URL',
      onEachFeature: 'handleAdminPolygons',
      layeroptions_protocol: 'WFS'
    },
    'State Boundaries': {
      source: 'INDIA',
      displayName: 'State Boundaries',
      name: 'State Boundaries',
      visible: true,
      view: AgricultureMapConstants.VIEWS.ADMIN,
      dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
      layerptions_show_on_selector: false,
      layeroptions_name: 'HEATWAVE:ALL_INDIA_STATE_UPDATED',
      layer_name: 'State Boundaries',
      layeroptions_pane: 'depth',
      layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.STATE].MIN,
      layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.STATE].MAX,
      group: 'boundaries',
      group_type: 'radio-deselect',
      layerServiceType: LAYER_TYPES.GEOJSON_LAYER,
      type: LAYER_TYPES.GEOJSON_LAYER,
      cql_filter_value: 'uuid',
      cql_filter: null,
      layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
      environment_server_url: 'COMMON_GEOSERVER_URL',
      onEachFeature: 'handleAdminPolygons',
      layeroptions_protocol: 'WFS'
    },
    'District Boundaries': {
      source: 'INDIA',
      displayName: 'District Boundaries',
      name: 'District Boundaries',
      visible: true,
      view: AgricultureMapConstants.VIEWS.ADMIN,
      dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
      layerptions_show_on_selector: false,
      layeroptions_name: 'HEATWAVE:ALL_INDIA_DISTRICT_UPDATED',
      layer_name: 'District Boundaries',
      layeroptions_pane: 'max',
      layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.DISTRICT].MIN,
      layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.DISTRICT].MAX,
      group: 'boundaries',
      group_type: 'radio-deselect',
      layerServiceType: LAYER_TYPES.GEOJSON_LAYER,
      type: LAYER_TYPES.GEOJSON_LAYER,
      cql_filter_value: 'uuid',
      cql_filter: null,
      layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
      environment_server_url: 'COMMON_GEOSERVER_URL',
      onEachFeature: 'handleAdminPolygons',
      layeroptions_protocol: 'WFS'
    },
    'State Boundary': {
      source: 'INDIA',
      displayName: 'State',
      name: 'State Boundary',
      visible: true,
      view: AgricultureMapConstants.VIEWS.ADMIN,
      dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
      layerptions_show_on_selector: false,
      layeroptions_name: 'HEATWAVE:ALL_INDIA_STATE_UPDATED',
      layer_name: 'State Boundary',
      layeroptions_pane: 'depth',
      layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.STATE].MIN - 1,
      layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.STATE].MAX,
      group: 'boundaries',
      group_type: 'radio-deselect',
      layerServiceType: LAYER_TYPES.VECTOR_LAYER,
      type: LAYER_TYPES.VECTOR_LAYER,
      cql_filter_value: null,
      cql_filter: null,
      layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
      environment_server_url: 'COMMON_GEOSERVER_URL',
      crs: 'EPSG4326',
      hasLables: true,
      applycql_filter: true,
      legendName: 'CTP_LEGEND',
      layeroptions_protocol: 'WFS'
    },
    'District Boundary': {
      source: 'INDIA',
      displayName: 'District',
      name: 'District Boundary',
      visible: true,
      view: AgricultureMapConstants.VIEWS.ADMIN,
      dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
      layerptions_show_on_selector: false,
      layeroptions_name: 'HEATWAVE:ALL_INDIA_DISTRICT_UPDATED',
      layer_name: 'District Boundary',
      layeroptions_pane: 'district',
      layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.STATE].MIN - 1,
      layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.DISTRICT].MAX,
      group: 'boundaries',
      group_type: 'radio-deselect',
      layerServiceType: LAYER_TYPES.VECTOR_LAYER,
      type: LAYER_TYPES.VECTOR_LAYER,
      cql_filter_value: null,
      cql_filter: null,
      layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
      environment_server_url: 'COMMON_GEOSERVER_URL',
      crs: 'EPSG4326',
      hasLables: true,
      legendName: 'CTP_LEGEND',
      applycql_filter: true,
      layeroptions_protocol: 'WFS'
    },
    'State Boundary Labels': {
      source: 'INDIA',
      displayName: 'State',
      name: 'State Boundary Labels',
      visible: true,
      view: AgricultureMapConstants.VIEWS.ADMIN,
      dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
      layerptions_show_on_selector: false,
      layeroptions_name: 'HEATWAVE:ALL_INDIA_STATE_UPDATED',
      layer_name: 'State Boundary Labels',
      layeroptions_pane: 'depth',
      layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.STATE].MIN - 1,
      layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.STATE].MAX,
      group: 'Labels',
      group_type: 'radio-deselect',
      layerServiceType: LAYER_TYPES.WMS_LAYER,
      type: LAYER_TYPES.WMS_LAYER,
      cql_filter: null,
      layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
      environment_server_url: 'COMMON_GEOSERVER_URL',
      layeroptions_styles: 'HEATWAVE:INDIA_STATE_NAMES_UPDATED',
      crs: 'EPSG4326',
    },
    'District Boundary Labels': {
      source: 'INDIA',
      displayName: 'District Boundary Labels',
      name: 'District Boundary Labels',
      visible: true,
      view: AgricultureMapConstants.VIEWS.ADMIN,
      dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
      layerptions_show_on_selector: false,
      layeroptions_name: 'HEATWAVE:ALL_INDIA_DISTRICT_UPDATED',
      layer_name: 'District Boundary Labels',
      layeroptions_pane: 'depth',
      layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.STATE].MIN - 2,
      layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.STATE].MAX,
      group: 'Labels',
      group_type: 'radio-deselect',
      layerServiceType: LAYER_TYPES.WMS_LAYER,
      type: LAYER_TYPES.WMS_LAYER,
      cql_filter_value: 'state_uuid',
      cql_filter: null,
      layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
      environment_server_url: 'COMMON_GEOSERVER_URL',
      layeroptions_styles: 'HEATWAVE:ALL_INDIA_DISTRICT_NAMES_UPDATED_CTT',
      crs: 'EPSG4326',
    },
    'Block Boundary': {
      source: 'INDIA',
      displayName: 'Block',
      name: 'Block Boundary',
      visible: true,
      view: AgricultureMapConstants.VIEWS.ADMIN,
      dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
      layerptions_show_on_selector: false,
      layeroptions_name: 'HEATWAVE:ALL_INDIA_BLOCKS_UPDATED',
      layer_name: 'Block Boundary',
      layeroptions_pane: 'depth',
      layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.STATE].MIN - 2,
      layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.DISTRICT].MAX,
      group: 'boundaries',
      group_type: 'radio-deselect',
      layerServiceType: LAYER_TYPES.VECTOR_LAYER,
      type: LAYER_TYPES.VECTOR_LAYER,
      cql_filter_value: null,
      cql_filter: null,
      layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
      environment_server_url: 'COMMON_GEOSERVER_URL',
      crs: 'EPSG4326',
      hasLables: true,
      applycql_filter: true,
      legendName: 'CTP_LEGEND',
      layeroptions_protocol: 'WFS'
    },
    'Block Boundary Labels': {
      source: 'INDIA',
      displayName: 'Block Boundary Labels',
      name: 'Block Boundary Labels',
      visible: true,
      view: AgricultureMapConstants.VIEWS.ADMIN,
      dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
      layerptions_show_on_selector: false,
      layeroptions_name: 'HEATWAVE:ALL_INDIA_BLOCKS_UPDATED',
      layer_name: 'Block Boundary Labels',
      layeroptions_pane: 'depth',
      layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.STATE].MIN - 2,
      layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.DISTRICT].MAX,
      group: 'Labels',
      group_type: 'radio-deselect',
      layerServiceType: LAYER_TYPES.WMS_LAYER,
      type: LAYER_TYPES.WMS_LAYER,
      cql_filter_value: 'dist_uuid',
      cql_filter: null,
      layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
      environment_server_url: 'COMMON_GEOSERVER_URL',
      layeroptions_styles: 'HEATWAVE:ALL_INDIA_BLOCK_LABELS_UPDATED_CTT',
      crs: 'EPSG4326',
    }
  }
};

export const SATELLITE_LEGEND_LIST: any = {
  [AgricultureMapConstants.LOCATIONS.INDIA]: {
    CTP_LEGEND: {
      colorValues: [
        { backgroundColor: '#5E0B0B', text: '<span class="ctp-lbl" data-ctp="&lt;-90°C">&lt;-90°C</span>',  textColor: '#ffffff' },
        { backgroundColor: '#BC0F0F', text: '<span class="ctp-lbl" data-ctp="-85°C">-85°C</span>',          textColor: '#ffffff' },
        { backgroundColor: '#F13317', text: '<span class="ctp-lbl" data-ctp="-80°C">-80°C</span>',          textColor: '#ffffff' },
        { backgroundColor: '#FF8A00', text: '<span class="ctp-lbl" data-ctp="-75°C">-75°C</span>',          textColor: '#000000' },
        { backgroundColor: '#FFC000', text: '<span class="ctp-lbl" data-ctp="-70°C">-70°C</span>',          textColor: '#000000' },
        { backgroundColor: '#F5FF08', text: '<span class="ctp-lbl" data-ctp="-65°C">-65°C</span>',          textColor: '#000000' },
        { backgroundColor: '#A6FF4D', text: '<span class="ctp-lbl" data-ctp="-62°C">-62°C</span>',          textColor: '#000000' },
        { backgroundColor: '#72FF68', text: '<span class="ctp-lbl" data-ctp="-60°C">-60°C</span>',          textColor: '#000000' },
        { backgroundColor: '#00FFFF', text: '<span class="ctp-lbl" data-ctp="-55°C">-55°C</span>',          textColor: '#000000' },
        { backgroundColor: '#00CDFF', text: '<span class="ctp-lbl" data-ctp="-52°C">-52°C</span>',          textColor: '#000000' },
        { backgroundColor: '#00A7FF', text: '<span class="ctp-lbl" data-ctp="-50°C">-50°C</span>',          textColor: '#000000' },
        { backgroundColor: '#0066FF', text: '<span class="ctp-lbl" data-ctp="-49°C">-49°C</span>',          textColor: '#ffffff' },
        { backgroundColor: '#0000E6', text: '<span class="ctp-lbl" data-ctp="-42°C">-42°C</span>',          textColor: '#ffffff' },
        { backgroundColor: '#00007F', text: '<span class="ctp-lbl" data-ctp="-40°C">-40°C</span>',          textColor: '#ffffff' },
        { backgroundColor: '#E6E6FA', text: '<span class="ctp-lbl" data-ctp="-35°C">-35°C</span>',          textColor: '#000000' },
        { backgroundColor: '#CCCCCC', text: '<span class="ctp-lbl" data-ctp="-30°C">-30°C</span>',          textColor: '#000000' },
        { backgroundColor: '#999999', text: '<span class="ctp-lbl" data-ctp="-20°C">-20°C</span>',          textColor: '#000000' },
        { backgroundColor: '#606060', text: '<span class="ctp-lbl" data-ctp="-10°C">-10°C</span>',          textColor: '#ffffff' },
        { backgroundColor: '#2D2D2D', text: '<span class="ctp-lbl" data-ctp="0°C">0°C</span>',             textColor: '#ffffff' },
        { backgroundColor: '#0C0C0C', text: '<span class="ctp-lbl" data-ctp="&gt;10°C">&gt;10°C</span>',   textColor: '#ffffff' },
      ]
    }
  }
};
